"use client";

import {
  NavigationItem,
  NavigationItemProps,
} from "@/app/(discover)/components/sidebar/navigation-item";
import { useClientFeatureFlag } from "@/hooks/use-client-feature-flag";
import routes from "@/lib/routes";
import { useAuth } from "@/stores/use-auth";

export default function ApplicationsNavigationItem(props: NavigationItemProps) {
  const { user } = useAuth();
  const showApplicationsList = useClientFeatureFlag("applicationslist");

  if (user && !showApplicationsList) {
    const candidateDashboardUrl = routes.getCandidateDashboardFromDiscover(
      routes.getJobs(),
    );

    return (
      <NavigationItem
        {...props}
        url={candidateDashboardUrl}
        target="_blank"
        rel="noopener noreferrer"
      />
    );
  }

  return <NavigationItem {...props} url={routes.getCandidateApplications()} />;
}
